import styled from 'styled-components';
import {
  TablePagination as MuiTablePagination, TablePaginationProps
} from '@material-ui/core';

export const TableTitle = styled.h3`
  font-family: MontSerrat-SemiBold;
  font-size: 1.8rem;
  padding: 8px 0;
  color: var(--colorGray);
`;

export const TableFooter = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

interface TablePaginationOwnProps extends TablePaginationProps<any> {
  component: string
}

export const TablePagination = styled(MuiTablePagination)<TablePaginationOwnProps>`
  & .MuiTablePagination-caption {
    font-size: 0.9rem
  };

  & .MuiTablePagination-input {
    font-size: 0.9rem
  };

  & .MuiSelect-select.MuiSelect-select {
    border-radius: 20px
  };

  & .MuiSelect-icon {
    right: 4px
  }
`;

export const SelectedItems = styled.span`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1.2rem;
`;